import client from '../common/client';
import config from '../config';
import uuid from 'uuid';
import store from 'store2';

export const GET_USER = 'GET_USER';
export const CREATE_AFFILIATE = 'CREATE_AFFILIATE';
export const CREATE_USER = 'CREATE_USER';
export const GET_GIFT_SUBSCRIPTION_PRICE = 'GET_GIFT_SUBSCRIPTION_PRICE';
export const PURCHASE_GIFT_SUBSCRIPTIONS = 'PURCHASE_GIFT_SUBSCRIPTIONS';
export const PUSH_TOAST = 'PUSH_TOAST';
export const SHIFT_TOAST = 'SHIFT_TOAST';
export const VALIDATE_PROMO_CODE = 'VALIDATE_PROMO_CODE';

export const getUser = userId => ({
  promise: client.get(`users/${userId}`),
  type: GET_USER,
});

export const pushToast = payload => dispatch => {
  setTimeout(() => {
    dispatch({ type: SHIFT_TOAST });
  }, 5000);
  dispatch({
    type: PUSH_TOAST,
    payload,
  });
};

export const createAndSubscribeUser = payload => {
  const nonce = uuid();
  store.set('nonce', nonce);

  const userData = {
    ...payload,
    clientId: config.auth.clientId,
    redirectUri: config.auth.redirectUri,
    scope: config.auth.scope,
    nonce,
  };

  if (window.tap && window.tap.vid) {
    userData.tapfiliateVid = window.tap.vid;
  }

  return {
    promise: client.post(`users`, userData),
    type: CREATE_USER,
  };
};

export const validatePromoCode = code => ({
  promise: client.post('promo-code', { code }),
  type: VALIDATE_PROMO_CODE,
});

export const resetPromoCode = () => ({
  type: `${VALIDATE_PROMO_CODE}_RESET`,
});

export const getGiftSubscriptionPrice = () => ({
  promise: client.get('gift-subscription-price'),
  type: GET_GIFT_SUBSCRIPTION_PRICE,
});

export const purchaseGiftSubscriptions = payload => {
  const subData = { ...payload };

  if (window.tap && window.tap.vid) {
    subData.tapfiliateVid = window.tap.vid;
  }

  return {
    promise: client.post('gift-subscriptions', subData),
    type: PURCHASE_GIFT_SUBSCRIPTIONS,
  };
};

export const createAffiliate = payload => ({
  promise: client.post('affiliates', payload),
  type: CREATE_AFFILIATE,
});



// WEBPACK FOOTER //
// ./src/redux/actions.js